// extracted by mini-css-extract-plugin
export var callout = "callout-module--callout--3Rgge";
export var calloutContainer = "callout-module--callout__container--DKFGK";